import { render, staticRenderFns } from "./StoresMap.vue?vue&type=template&id=180d6353&scoped=true"
import script from "./StoresMap.vue?vue&type=script&lang=js"
export * from "./StoresMap.vue?vue&type=script&lang=js"
import style0 from "./StoresMap.vue?vue&type=style&index=0&id=180d6353&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "180d6353",
  null
  
)

export default component.exports